var render = function render(){var _vm=this,_c=_vm._self._c;return _c('event-management',{attrs:{"get-roles":_vm.getRoles,"get-categories":_vm.getCategories,"get-event":_vm.getEvent,"save-event":_vm.saveEvent,"update-event":_vm.updateEvent,"exist-sie":_vm.existSie,"get-applications":_vm.getApplications,"component-options":_vm.componentOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }